module.exports = __webpack_public_path__ + "img/single-student-icon.8bd8d9c4.svg";